<template>
  <div
    id="app"
    v-loading="loading"
    element-loading-text="正在加载中..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.7)"
  >
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
    };
  },
  mounted() {
    window._loading = (loading) => {
      this.loading = loading;
    };
  },
};
</script>

<style>
body {
  margin: 0;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;

  width: 100vw;
  max-height: 100vh;
}

#app .el-loading-mask {
  z-index: 9999;
  position: fixed;
}
.el-form--label-top .el-form-item__label {
  float: left !important;
}
.el-message-box {
  width: 70% !important;
  max-width: 400px;
}
</style>
